import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconUnarchiveSvg } from "./IconUnarchiveSvg.mjs";
const IconUnarchive = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconUnarchiveSvg, ...iconProps });
};
export {
  IconUnarchive
};
